import React, { useState } from "react";
import { SampleExamLog } from "../../../types/sampleExamLog";
import { CardContent, Grid, Paper, Theme, useMediaQuery, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@material-ui/core";
import MaterialTable from "material-table";
import { materialTableLocalization } from "../../../constants/materialTableLocalization";
import GetAppIcon from "@material-ui/icons/GetApp";

interface SampleExamLogComponentProps {
    sampleExamLogs: SampleExamLog[];
    loading: boolean;
    error?: string;
    exportSampleExamLogs: (filters?: any) => void;
}

const SampleExamLogComponent = ({ error, sampleExamLogs, loading, exportSampleExamLogs }: SampleExamLogComponentProps) => {
    const theme: Theme = useTheme();
    const fullscreen = useMediaQuery(theme.breakpoints.down("xs"));

    const [exportDialogOpen, setExportDialogOpen] = useState(false);
    const [cursistNr, setCursistNr] = useState("");
    const [locationCode, setLocationCode] = useState("");

    const handleExportConfirm = () => {
        const filters: any = {};

        if (cursistNr) {
            filters.cursistNr = parseInt(cursistNr);
        } else if (locationCode) {
            filters.locationCode = locationCode;
        }

        exportSampleExamLogs(Object.keys(filters).length > 0 ? filters : undefined);

        setExportDialogOpen(false);
        setCursistNr("");
        setLocationCode("");
    };

    return (
        <>
            <Grid container >
                <Grid item xs={12}>
                    <Paper style={{ marginTop: "1em" }}>
                        <CardContent>
                            <MaterialTable
                                style={{ boxShadow: "none", marginBottom: "2em", maxWidth: fullscreen ? "300px" : "none" }}
                                columns={[
                                    { title: "Id", field: "sampleExamLogId", type: "numeric", align: "left", defaultSort: "desc" },
                                    { title: "Datum", field: "entryDate", type: "string" },
                                    { title: "Cursistnr", field: "cursistNr", type: "numeric", align: "left" },
                                    { title: "ProefexamenId", field: "sampleExamId", type: "numeric", align: "left" },
                                    { title: "Aantal vragen", field: "amountOfQuestions", type: "numeric", align: "left" },
                                    { title: "Aantal goed", field: "amountCorrect", type: "numeric", align: "left" },
                                    { title: "Cijfer", field: "grade", type: "numeric", align: "left" }
                                ]}
                                options={{
                                    pageSize: 10,
                                    pageSizeOptions: [5, 10, 20, 50, 100],
                                }}
                                localization={materialTableLocalization}
                                data={sampleExamLogs}
                                title="Proefexamenlog"
                                actions={[
                                    {
                                        icon: () => <GetAppIcon />,
                                        tooltip: "Exporteer naar Excel",
                                        isFreeAction: true,
                                        onClick: () => setExportDialogOpen(true)
                                    }
                                ]}
                            />
                        </CardContent>
                    </Paper>
                </Grid>
            </Grid>

            <Dialog open={exportDialogOpen} onClose={() => setExportDialogOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Exporteer Proefexamen Logs naar Excel</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} style={{ marginTop: 8 }}>
                        <Grid item xs={12}>
                            <TextField
                                label="Cursistnummer"
                                type="number"
                                fullWidth
                                value={cursistNr}
                                onChange={(e) => {
                                    setCursistNr(e.target.value);
                                    if (e.target.value) {
                                        setLocationCode("");
                                    }
                                }}
                                helperText="Filter op specifiek cursistnummer"
                                disabled={!!locationCode}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Locatiecode"
                                type="text"
                                fullWidth
                                value={locationCode}
                                onChange={(e) => {
                                    setLocationCode(e.target.value);
                                    if (e.target.value) {
                                        setCursistNr("");
                                    }
                                }}
                                helperText="Filter op locatiecode"
                                disabled={!!cursistNr}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ fontSize: "0.875rem", color: "#666", marginTop: "8px" }}>
                            Vul één van beide velden in om te exporteren
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setExportDialogOpen(false)} color="default">
                        Annuleren
                    </Button>
                    <Button
                        onClick={handleExportConfirm}
                        color="primary"
                        variant="contained"
                        startIcon={<GetAppIcon />}
                        disabled={!cursistNr && !locationCode}
                    >
                        Exporteer
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default SampleExamLogComponent;